export type UserPortfolioSnapshotQueryKey = readonly [
  'users',
  'detail',
  string,
  'portfolio-snapshot',
];

export function userPortfolioSnapshotQueryKey(userId: string): UserPortfolioSnapshotQueryKey {
  return ['users', 'detail', userId, 'portfolio-snapshot'];
}
